<template>
  <van-nav-bar
    :title="header_title"
    :left-text="left_text"
    :left-arrow="left_arrow"
    :fixed="header_fixed"
    :border="header_border"
    @click-left="goBack"
    :newsShow="newsShow"
    :backRouter="backRouter"
    :z-index="99"
    :class="{part:part_background}"
  >
    <van-icon
      name="bell"
      slot="right"
      size="1.5em"
      @click="linkToNews"
      v-if="newsShow"
      :class="{ notice: hasNotice }"
    />
  </van-nav-bar>
</template>
<script>
import {
  getIndividualHeaderKey
} from "@/utils/auth";
import Bus from "../Bus"
import { NavBar, Icon } from "vant";
export default {
  name: "job-header-simple",
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon
  },
  props: {
    header_title: {
      type: String
    },
    header_border: {
      type: Boolean,
      default: false
    },
    left_arrow: {
      type: Boolean,
      default: true
    },
    left_text: {
      type: String,
      default: "返回"
    },
    newsShow: {
      type: Boolean,
      default: false
    },
    backRouter: {
      type: String,
      default: "0"
    },
    hasNotice: {
      type: Boolean,
      default: false
    },
    header_fixed: {
      type: Boolean,
      default: true
    },
    part_background: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    goBack() {
      // 个体户身份认证、视频认证、签名页等认证相关返回至个体户列表页
      if(getIndividualHeaderKey()&&this.$route.meta.identity === "individual"){
        return this.$router.push("/individual_list");
      }
  /*    if (this.$route.path=='/privacy'){
        if (this.$route.query.fromWhere=="/register"){
          this.$router.push({
            path:'/register',
            query:{fromWhere:this.$route.query.fromWhere}
          })
          return this.$route.go(-1)
        }
      }*/
      if (this.backRouter == "0") {
        if (window.history.length > 1){
          if (this.$route.path=='/privacy'){
            if (this.$route.query.fromWhere=="/register"){
              localStorage.setItem('fromWhere',this.$route.query.fromWhere);
            }
          }
          return this.$router.go(-1);
        }else {
          return  this.$router.push("/");
        }
       /* return window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");*/
      } else {
        if (this.backRouter.length > 2) {
          return this.$router.push(this.backRouter);
        } else {
          let backRouter = parseInt(this.backRouter);
          return this.$router.go(backRouter);
        }
      }
    },
    linkToNews() {
      return this.$router.push("/news");
    }
  }
};
</script>
<style lang="less" scoped>
.notice {
  &:after {
    content: " ";
    width: 6px;
    height: 6px;
    background: #ff3434;
    border-radius: 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.part {
  background: #6275f0;
  color: white;
  /deep/ .van-nav-bar__title{
    color: white;
  }
  /deep/ .van-icon{
    color: white;
  }
}
</style>
